import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import StorySection from './components/StorySection';
import MissionSection from './components/MissionSection';
import ValuesSection from './components/ValuesSection';
import StatsSection from './components/StatsSection';
import MilestonesSection from './components/MilestonesSection';
import CtaSection from './components/CtaSection';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Hero />
        <StorySection />
        <MissionSection />
        <ValuesSection />
        <StatsSection />
        <MilestonesSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}